
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { redirect } from 'react-router-dom';
import { useEffect,useState } from 'react';
import Home from "../Home/Home";

const CommitteeMembers = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const roleMap = {
    1: "Website Administrator",
    2: "Core Committee",
    3: "Food Committee",
    4: "Decoration Committee",
    5: "Cultural Committee",
    6: "Finance Committee",
  };

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/user/committee")
        .then(response => response.json())
        .then(data => {
          setMembers(data);
          setLoading(false);
        })
        .catch(error => {
          console.error("Error fetching members:", error);
          setLoading(false);
        });
  }, []);

  // Group members by role
  const groupedMembers = members.reduce((acc, member) => {
    const role = member.userRole;
    if (!acc[role]) acc[role] = [];
    acc[role].push(member);
    return acc;
  }, {});

  if (loading) return <p>Loading members...</p>;

  return (
     <Home>
      <div className="container">
        <h2 className="text-center">Committee Members</h2>
        {Object.entries(groupedMembers).map(([roleId, members]) => (
            <div key={roleId} className="mb-4">
              <h4>{roleMap[roleId] || "Unknown Committee"}</h4>
              <table className="table table-bordered table-striped">
                <thead>
                <tr>
                  <th>Name</th>
                  <th>State</th>
                  <th>Email</th>
                </tr>
                </thead>
                <tbody>
                {members.map((member, idx) => (
                    <tr key={idx}>
                      <td>{member.firstName} {member.lastName}</td>
                      <td>{member.state}</td>
                      <td>
                        <a href={`mailto:${member.email}`}>{member.email}</a>
                      </td>
                    </tr>
                ))}
                </tbody>
              </table>
            </div>
        ))}
      </div>
      </Home>
  );
};

export default CommitteeMembers;